<template>
  <div class="bg-gray-50 p-sm rounded-sm border border-solid border-gray-200">
    <div class="flex justify-space-between align-items-center m-b-sm">
      <span class="font-semi text-14">Edit {{ member.profile.full_name }}</span>
      <button
        type="button"
        class="btn btn-link btn-xs p-none"
        @click="$emit('cancel')"
      >
        <i class="fa-solid fa-xmark"></i>
      </button>
    </div>

    <div class="form-group m-b-xs">
      <label class="text-12">Weight</label>
      <input
        v-model="weightClass"
        type="text"
        class="form-control input-sm"
        placeholder="e.g. 120"
      />
    </div>

    <div class="form-group m-b-xs">
      <label class="text-12">Date of Birth</label>
      <the-mask
        mask="##/##/####"
        placeholder="mm/dd/yyyy"
        v-model="dob"
        class="form-control input-sm"
        :masked="true"
        type="tel"
      />
    </div>

    <div class="form-group m-b-xs">
      <label class="text-12">Gender</label>
      <select v-model="gender" class="form-control input-sm">
        <option value="">Choose gender...</option>
        <option value="male">Male</option>
        <option value="female">Female</option>
      </select>
    </div>

    <div class="form-group m-b-sm">
      <label class="text-12">Academic Class</label>
      <select v-model="academicClass" class="form-control input-sm">
        <option value="">Choose academic class...</option>
        <optgroup label="Pre-K to 12">
          <option value="Pre-K">Pre-K</option>
          <option value="Kindergarten">Kindergarten</option>
          <option value="1st grade">1st grade</option>
          <option value="2nd grade">2nd grade</option>
          <option value="3rd grade">3rd grade</option>
          <option value="4th grade">4th grade</option>
          <option value="5th grade">5th grade</option>
          <option value="6th grade">6th grade</option>
          <option value="7th grade">7th grade</option>
          <option value="8th grade">8th grade</option>
          <option value="9th grade">9th grade</option>
          <option value="10th grade">10th grade</option>
          <option value="11th grade">11th grade</option>
          <option value="12th grade">12th grade</option>
        </optgroup>
        <optgroup label="College">
          <option value="Freshmen">Freshmen</option>
          <option value="RS Freshmen">RS Freshmen</option>
          <option value="Sophomore">Sophomore</option>
          <option value="RS Sophomore">RS Sophomore</option>
          <option value="Junior">Junior</option>
          <option value="RS Junior">RS Junior</option>
          <option value="Senior">Senior</option>
          <option value="RS Senior">RS Senior</option>
          <option value="Grad Student">Grad Student</option>
        </optgroup>
        <optgroup label="Other">
          <option value="other">Other</option>
        </optgroup>
      </select>
    </div>

    <div v-if="error" class="text-danger text-12 m-b-xs">
      {{ errorMessage }}
    </div>

    <div class="flex gap-xs">
      <button
        type="button"
        class="btn btn-primary btn-sm"
        :disabled="saving"
        @click="save"
      >
        <span v-if="saving">Saving...</span>
        <span v-else>Save</span>
      </button>
      <button
        type="button"
        class="btn btn-default btn-sm"
        :disabled="saving"
        @click="$emit('cancel')"
      >
        Cancel
      </button>
    </div>
  </div>
</template>

<script>
import { TheMask } from 'vue-the-mask';

export default {
  name: 'RosterWrestlerInlineEdit',
  components: { TheMask },
  props: {
    member: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      saving: false,
      error: false,
      errorMessage: '',
      weightClass: '',
      dob: '',
      gender: '',
      academicClass: '',
    };
  },
  computed: {
    isoDob() {
      if (!this.dob || this.dob.length < 10) {
        return null;
      }
      return moment(this.dob, 'MM/DD/YYYY').toISOString();
    },
  },
  created() {
    // Initialize from member data
    const profile = this.member.profile || {};
    this.weightClass = profile.weight_class || '';
    this.gender = profile.gender || '';
    this.academicClass = profile.academic_class || '';

    if (profile.dob) {
      this.dob = moment(profile.dob).format('MM/DD/YYYY');
    }
  },
  methods: {
    save: _.throttle(function () {
      if (this.saving) return;

      this.saving = true;
      this.error = false;

      const params = {
        wrestler_profile: {
          weight_class: this.weightClass,
          dob: this.isoDob,
          gender: this.gender,
          academic_class: this.academicClass,
        },
      };

      const url = this.$apiService.wrestlerUrl(this.member.profile.id);
      axios
        .put(url, params)
        .then((response) => {
          this.saving = false;
          // Emit updated data so parent can update local state
          this.$emit('saved', {
            profileId: this.member.profile.id,
            weight_class: this.weightClass,
            dob: this.isoDob,
            gender: this.gender,
            academic_class: this.academicClass,
          });
          this.$notificationManager.emit(
            'show-toast',
            'Wrestler details updated',
            true,
          );
        })
        .catch((error) => {
          this.saving = false;
          this.error = true;
          this.errorMessage = 'Error saving wrestler details. Please try again.';
        });
    }, 500),
  },
};
</script>
